import type { Listing } from '@thevillages/schemas';

import { Component, inject, input } from '@angular/core';

import { SaveService } from '../../../services/save/save';
import { StateService } from '../../../services/state/state';
import { ListingDetailsActions } from '../actions/actions';
import { ListingDetailsFeaturesDetails } from '../features-details/features-details';
import { ListingDetailsInfo } from '../info/info';
import { ListingDetailsVillageDetails } from '../village-details/village-details';
import { ListingDetailsWillAccommodate } from '../will-accommodate/will-accommodate';

@Component({
  imports: [
    ListingDetailsActions,
    ListingDetailsFeaturesDetails,
    ListingDetailsInfo,
    ListingDetailsVillageDetails,
    ListingDetailsWillAccommodate,
  ],
  selector: 'app-homesite-listing-details',
  styleUrl: './homesite.css',
  templateUrl: './homesite.html',
})
export class HomesiteListingDetails {
  protected readonly saveService = inject(SaveService);
  protected readonly stateService = inject(StateService);

  public readonly listing = input.required<Listing>();
}
